import React from 'react'
import { Formik } from 'formik'
import { Row, Col, Divider, Form, Button } from '_zari/core'

import Yup from '_zari/validation/_yup'
import { ZariContext } from '_zari/context'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import TituloFormGroup from './formGroups/titulo'

import DetallesSection from './sections/detalles'

import * as TempInventarioCrud from 'services/tempInventario.service'

import { RetrocederButton } from 'sharedComponents/buttons'

const ValidationSchema = Yup.object().shape({
  titulo: Yup.string().required()
})

const actualizarFila = (current, { cantidad, ...restPayload }) => {
  current = {
    ...current,
    ...restPayload,
    cantidad
  }

  return current
}

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      let newState = state
        .map(val => ({
          ...val,
          __filaActiva: false,
          __focusCantidad: false,
          __focusDescuento: false,
          __focusPrecio: false,
          esFilaBusqueda: false
        }))
        .filter(x => x._idProductoPresentacion)

      let { viaCodBar, _id, ...payload } = action.payload
      return [
        ...newState,
        {
          ...payload,
          __filaActiva: !viaCodBar,
          __focusCantidad: !viaCodBar,
          _idProductoPresentacion: _id,
          _idFila: Math.round(new Date() / 1000),
          cantidad: '1'
        },
        {
          __filaActiva: viaCodBar,
          esFilaBusqueda: true,
          _idFila: `${Math.round(new Date() / 1000)}-G`
        }
      ]
    }
    case 'actualizar': {
      const { aplicarTodos, saltarFila, ...nuevoPayload } = action.payload
      return state.map(val => {
        if (val.esFilaBusqueda) {
          val.__filaActiva = saltarFila
        } else {
          if (val._idFila === nuevoPayload._idFila) {
            val = actualizarFila(val, nuevoPayload)
          }
          val.__filaActiva = !saltarFila
        }
        return val
      })
    }
    case 'actualizarComentario':
      return state.map((val, i) => {
        if (val._idFila === action.payload._idFila) {
          val.comentario = action.payload.comentario
        }
        return val
      })
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const MainForm = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const [detalles, detallesDispatcher] = React.useReducer(commonReducer, [
    {
      esFilaBusqueda: true,
      _idFila: Math.round(new Date() / 1000)
    }
  ])

  const formInitialValues = React.useMemo(() => {
    return {
      titulo: ''
    }
  }, [])

  const submitHandler = React.useCallback(
    data => {
      const detallesNormalizados = detalles
        .filter(x => x._idProductoPresentacion)
        .map(x => {
          return {
            _idProductoPresentacion: x._idProductoPresentacion,
            cantidad: parseFloat(x.cantidad)
          }
        })

      TempInventarioCrud.nuevoTempInventario({
        ...data,
        detalles: detallesNormalizados
      })
        .then(() => {
          __zariContext.snack('success', 'El registro se ha agregado.')
          history.push(`/${CodigosTransaccionesConstant.INVENTARIOS_INGRESOMANUAL_LISTA}`)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [detalles, __zariContext, history]
  )

  return (
    <Row>
      <Col md={12}>
        <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
          {({ errors, handleSubmit, isSubmitting, touched }) => (
            <>
              <Form>
                <Row>
                  <Col md={4}>
                    <TituloFormGroup fIsSubmitting={isSubmitting} iError={errors.titulo} iTouched={touched.titulo} />
                  </Col>
                </Row>
                <Divider />
                <DetallesSection detalles={detalles} dispatch={detallesDispatcher} />
                <Divider />
                <Row>
                  <Col md={12} className='text-right'>
                    <RetrocederButton />
                    <Button disabled={isSubmitting} className='ml-2' onClick={handleSubmit}>
                      Guardar
                    </Button>
                  </Col>
                </Row>
              </Form>
            </>
          )}
        </Formik>
      </Col>
    </Row>
  )
}

export default MainForm
